"use strict";
// Copyright (c) 2018-2022 Coinbase, Inc. <https://www.coinbase.com/>
// Licensed under the Apache License, version 2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.Web3Method = void 0;
var Web3Method;
(function (Web3Method) {
    Web3Method["requestEthereumAccounts"] = "requestEthereumAccounts";
    Web3Method["signEthereumMessage"] = "signEthereumMessage";
    Web3Method["signEthereumTransaction"] = "signEthereumTransaction";
    Web3Method["submitEthereumTransaction"] = "submitEthereumTransaction";
    Web3Method["ethereumAddressFromSignedMessage"] = "ethereumAddressFromSignedMessage";
    Web3Method["scanQRCode"] = "scanQRCode";
    Web3Method["generic"] = "generic";
    Web3Method["childRequestEthereumAccounts"] = "childRequestEthereumAccounts";
    Web3Method["addEthereumChain"] = "addEthereumChain";
    Web3Method["switchEthereumChain"] = "switchEthereumChain";
    Web3Method["makeEthereumJSONRPCRequest"] = "makeEthereumJSONRPCRequest";
    Web3Method["watchAsset"] = "watchAsset";
    Web3Method["selectProvider"] = "selectProvider";
})(Web3Method = exports.Web3Method || (exports.Web3Method = {}));
